import { AddressTypes } from '@sg/garnish';
import type { Address, Order } from '@sg/graphql-schema';

// ────────────────────────────────────────────────────────────────────────────────

export function checkIfDeliveryOrder(order: Order) {
  const orderType = order.orderType.toLowerCase();
  const deliveryOrderType = AddressTypes.delivery.toLowerCase();

  return orderType === deliveryOrderType;
}

export function checkIfHasValidDeliveryAddress(
  order: Order,
  customerAddressesIds: ReadonlySet<string>,
) {
  const deliveryAddressId = order.deliveryOrderDetail?.address?.id ?? '';

  return customerAddressesIds.has(deliveryAddressId);
}

export function getCustomerAddressesIds(customerAddresses: readonly Address[] = []) {
  return new Set(customerAddresses.map((address) => address.id));
}
